export enum Category {
  TrainStation = 'TrainStation',
  Airport = 'Airport',
  Harbor = 'Harbor',
  AmusementPark = 'AmusementPark',
  Hotel = 'Hotel',
  Arena = 'Arena',
  Club = 'Club',
  Zoo = 'Zoo',
  BusStation = 'BusStation',
  Unspecified = 'Unspecified',
}
